const appContext = "/";
export const API_KEY = "API_KEY";
export const APP_NAME = "Due Diligence App";
export const APP_REDIRECT_URL_KEY = "dd-app-redirect-url";

export const AUTH_CONFIG = {
  signInRedirectURL: `${window.config?.REACT_APP_AUTH_SIGNIN_REDIRECT_URL}`,
  signOutRedirectURL: `${window.config?.REACT_APP_AUTH_SIGNOUT_REDIRECT_URL}`,
  clientID: `${window.config?.REACT_APP_ASGARDEO_CLIENT_ID}`,
  serverOrigin: `${window.config?.REACT_APP_ASGARDEO_SERVER_ORIGIN}`,
  baseUrl: `${window.config?.REACT_APP_ASGARDEO_SERVER_ORIGIN}`,
  scope: ["openid", "profile", "email", "groups"],
};

export const CHOREO_HEADERS = {
  Authorization:
    "Basic " + btoa(`${window.config?.REACT_APP_CHOREO_CLIENT_ID}:${window.config?.REACT_APP_CHOREO_CLIENT_SECRET}`),
  "Content-Type": "application/x-www-form-urlencoded",
};

export const AppConfig = {
  externalUrl: window.config?.REACT_APP_CLIENT_BASE_URL + "/",
  baseUrl: window.config?.REACT_APP_ADMIN_SERVICE_URL + "/",
  FileServiceURL: "http://localhost:37091/getFile",
  defaultTabName: "partners",
  tabs: ["partners", "tradereferences", "preferences"],
  resellerDashboardTabs: ["profile", "finance", "legal", "approvalsummary"],
  // Page URL List
  urls: {
    APP_CONTEXT: appContext,
    ADMIN: appContext + "admin/",
    CLIENT: appContext + "client/",
    LANDING_PAGE: "home/",
    PENDING_PAGE: "partner-dashboard/pending/",
    RESELLER_DASHBOARD: "partner-dashboard/",
    PENDING_PAGE_2: "tradereference/pending/",
    REJECTED_PAGE: "tradereference/rejected/",
    DEACTIVATED_PAGE: "tradereference/deactivated/",
    TRADE_REFERENCE: "tradereference/",
    TRADE_REFERENCES: "tradereferences/",
    VIEW_PDF: "view-pdf/",
    VIEW_IMAGE: "view-image/",
    NO_ACCESS_PAGE: "403/",
    NOT_FOUND_PAGE: "404/",
    RESELLER_FORM: "resellerform",
    RESELLER_FORM_VALIDATE: "resellerform/validate/",
    RESELLER_FORM_COMPLIANCE: "resellerform/compliance/",
    TRADE_REFERENCE_FORM: "tradereferenceform/",
    TRADE_REFERENCE_FORM_VALIDATE: "tradereferenceform/validate/",
  },

  // Service Endpoints List
  partnerData: "partners/",
  tradeReferenceData: "trade-references/",
  formStatus: "form-status",
  partnerLink: "partner/link",
  partnerQuestions: "partners/questions",
  partnerAnswers: "partners/answers",
  answers: "answers",
  files: "files",
  countries: "countries",
  creditScoreItems: "credit-score-items/",
  ratioScales: "ratio-scales/",
  notificationEmails: "emails/",
  financeFeedback: "finance/feedback/",
  financeComments: "finance/comments/",
  linkData: "link-id/",
  legalQuestions: "questions/legal",
  legalAnswers: "answers/legal",
  approvalSummary: "approval-summary/",
  legalApproval: "legal-approval",
  linkStatus: "link-status",
  tradeReferenceFormStatus: "trade-reference/form-status/",
  fileUpload: "files/",
  saveNewFiles: "files/metadata",
  fileDelete: "files",
  enableTradeReference: "enable-trade-ref",

  getResellerQuestionData: "getResellerInfoQuestions/",
  getResellerAnswers: "getResellerAnswers/",
  insertFinancialFeedback: "insertFinancialFeedback/",
  insertLegalApproval: "insertLegalApproval/",
  insertFinanceComments: "insertFinanceComments/",

  getLegalInfoQuestions: "getLegalInfoQuestions/",
  getLegalAnswers: "getLegalAnswers/",
  resFile: "res-file",
  getResellers: "partners/",
  getTradeReferences: "trade-references/",
  getTradeReferenceQuestionData: "trade-references/info/questions",
  getResellerDataByCompanyId: "partners/",
  sendApprovalEmail: "approval-email",
  sendSpecialApprovalEmail: "special-approval-email",
  resendEmail: "resend-email",

  getTradeReferenceLinkId: "getTradeRefLinkdId/",
  updateResellerFormStatus: "updateResellerFormStatus/",
  insertCreditScoreItems: "insertCreditScoreItems",
  getPreferences: "preferences",
  insertNotificationEmail: "emails/",
  deleteNotificationEmail: "deleteNotificationEmail",
  getNotificationEmails: "emails/",
  changeResellerExpiry: "changeResellerExpiry",
  renewLink: "renew",
  legalComments: "legal/comments",
};

export const roles = window.config?.REACT_APP_ROLES;

export const FORM_STATUS = {
  SIGNED: "signed",
  COMPLETED: "completed",
  EDIT_COMPLETED: "edit_completed",
  PENDING: "pending",
  ACTIVE: "active",
  DRAFTED: "drafted",
  TR_DRAFTED: "tr_drafted",
  TR_EDIT_REQUESTED: "tr_edit_requested",
  FULL_EDIT_REQUESTED: "full_edit_requested",
};

// Reseller form status constants as it would appear in the dashboard
export const RESELLER_FORM_STATUS = {
  COMPLETED: "Completed",
  PENDING_SIGNATURE: "Pending Signature",
  PENDING: "pending",
  EXPIRED: "expired",
  DRAFTED: "Drafted",
  REQUESTED_TO_EDIT: "Requested To Edit",
};

export const TRADE_REFERENCE_STATUS = {
    COMPLETED: "completed",
    //stored in the database as "pending" but displayed as "requested to edit"
    PENDING: "requested to edit",
    DRAFTED: "drafted",
    DEACTIVATED: "deactivated",
    REJECTED: "rejected",
    //stored in the database as "active" but displayed as "pending"
    ACTIVE: "pending",
    DEFAULT: "pending",
  };

export const COLUMN_NAMES = {
  COMPANY_NAME: "Company Name",
  CONTACT_EMAIL: "Contact Email",
  CHANNEL_MANAGER_EMAIL: "Channel Manager Email",
  COUNTRY: "Country",
  REGION: "Region",
  FORM_STATUS: "Form Status",
  FINANCE_APPROVAL: "Finance Approval",
  LEGAL_APPROVAL: "Legal Approval",
};

export const REGION = {
  NORTH_AMERICA: "north america",
  LATAM: "latam",
  MIDDLE_EAST: "middle east",
  ANZ: "anz",
  UK: "uk",
  EU: "eu",
  ASIA: "asia",
  AFRICA: "africa",
};

export const LINK_STATUS = {
  ACTIVE: "active",
  EXPIRED: "expired",
  INACTIVE: "inactive",
};

export const FINANCE_RESULT = {
  APPROVED: "approved",
  REJECTED: "rejected",
  PENDING: "pending",
  CREATOR_PENDING: "creator-pending",
  REVIEWER_PENDING: "reviewer-pending",
  APPROVAL_PENDING: "approval-pending",
};

export const LEGAL_RESULT = {
  APPROVED: "approved",
  REJECTED: "rejected",
  PENDING: "pending",
};

// These constants are used in place of hardcoded strings to represent the filtermap
export const FILTERS = {
  SIGNED: "signed",
  COMPLETED: "completed",
  PENDING: "pending",
  EXPIRED: "expired",
  DRAFTED: "drafted",
  REQUESTED_TO_EDIT: "requestedToEdit",
  APPROVED: "approved",
  REJECTED: "rejected",
  CREATOR_PENDING: "creatorPending",
  REVIEWER_PENDING: "reviewerPending",
  APPROVAL_PENDING: "approvalPending",
  NORTH_AMERICA: "northAmerica",
  LATAM: "latam",
  MIDDLE_EAST: "middleEast",
  ANZ: "anz",
  UK: "uk",
  EU: "eu",
  ASIA: "asia",
  AFRICA: "africa",
  OTHER: "other",
};

export const SPECIAL_APPROVAL_QID = 79;
export const LEGAL_RESULT_SUB_QID = 46;
export const LEGAL_OPINION_CATEGORY_ID = "3";
export const LEGAL_COMMENT_QUESTION_ID = 80;
export const LEGAL_APPROVAL_QUESTION_ID = 45;
export const FILE_UPLOAD_LIMIT = 5;
export const LEGAL_CHOOSE_FILE_SUBQUESTION_ID = 104;
export const FINANCE_CHOOSE_FILE_SUBQUESTION_ID = 100;
export const CREATOR_COMMENT_QUESTION_ID = 42;
export const REVIEWER_COMMENT_QUESTION_ID = 43;
export const APPROVER_COMMENT_QUESTION_ID = 44;

export const YEAR_COLUMN_DEFS = [
  {
    col: 1,
    label: "Year Before (N-2)",
    swapTargets: [
      { targetCol: 2, targetLabel: "Prior Year (N-1)" },
      { targetCol: 3, targetLabel: "Current (N)" },
    ],
  },
  {
    col: 2,
    label: "Prior Year (N-1)",
    swapTargets: [
      { targetCol: 1, targetLabel: "Year Before (N-2)" },
      { targetCol: 3, targetLabel: "Current (N)" },
    ],
  },
  {
    col: 3,
    label: "Current (N)",
    swapTargets: [
      { targetCol: 1, targetLabel: "Year Before (N-2)" },
      { targetCol: 2, targetLabel: "Prior Year (N-1)" },
    ],
  },
];
